// extracted by mini-css-extract-plugin
export default {"logo":"logo__1JmHD"};